export const locale = {
    lang: 'ar',
    data: {
        IMPORT: 'استيراد بطاقات من لوحة',
        BOARD: 'لوحة',
        SELECTION: 'اختيار',
        LIST: 'قائمة',
    }
};
